function normalizeText(value) {
  return String(value || "").trim().toLowerCase();
}

function getSelectedYMMVehicle() {
  if (window.YMM_SELECTED_VEHICLE) {
    return {
      make: window.YMM_SELECTED_VEHICLE.make,
      model: window.YMM_SELECTED_VEHICLE.model,
      year: Number(window.YMM_SELECTED_VEHICLE.year)
    };
  }

  if (window.selectedVehicle) {
    return {
      make: window.selectedVehicle.make,
      model: window.selectedVehicle.model,
      year: Number(window.selectedVehicle.year)
    };
  }

  try {
    const saved = JSON.parse(localStorage.getItem("ymm_selected_vehicle"));
    if (saved) {
      return {
        make: saved.make,
        model: saved.model,
        year: Number(saved.year)
      };
    }
  } catch (e) {}

  return null;
}

function findHardwareRule(vehicle) {
  if (!vehicle || !window.HF_VEHICLE_HARDWARE_RULES) return null;

  return window.HF_VEHICLE_HARDWARE_RULES.find((rule) => {
    return (
      normalizeText(rule.make) === normalizeText(vehicle.make) &&
      normalizeText(rule.model) === normalizeText(vehicle.model) &&
      Number(vehicle.year) >= Number(rule.year_start) &&
      Number(vehicle.year) <= Number(rule.year_end)
    );
  }) || null;
}

function buildHardwareMessage(vehicle, rule) {
  if (!vehicle) {
    return "Select your vehicle to see hitch hardware recommendations.";
  }

  let html = `<strong>${vehicle.year} ${vehicle.make} ${vehicle.model}</strong><br>`;

  if (!rule) {
    html += `No special hitch hardware recommendation found yet.`;
    return html;
  }

  html += `✅ Compatible with selected vehicle<br>`;

  if (rule.requires_hitch_extender) {
    html += `⚠️ Hitch Extender Required<br>`;
    if (rule.hitch_extender_reason) {
      html += `Reason: ${rule.hitch_extender_reason}<br>`;
    }
  } else {
    html += `✅ Hitch extender not required<br>`;
  }

  if (rule.requires_extended_hitch_pin) {
    html += `⚠️ Extended Hitch Pin Required<br>`;
  } else {
    html += `✅ Standard hitch pin works<br>`;
  }

  return html;
}

function renderHardwareBox() {
  const container = document.querySelector("[data-hf-hardware-box]");
  if (!container) return;

  const vehicle = getSelectedYMMVehicle();
  const rule = findHardwareRule(vehicle);
  container.innerHTML = buildHardwareMessage(vehicle, rule);
}

function renderHardwareUpsells() {
  const extenderEl = document.querySelector("[data-hf-extender-upsell]");
  const pinEl = document.querySelector("[data-hf-pin-upsell]");
  const vehicle = getSelectedYMMVehicle();
  const rule = findHardwareRule(vehicle);

  if (extenderEl) {
    extenderEl.style.display = rule && rule.requires_hitch_extender ? "" : "none";
  }

  if (pinEl) {
    pinEl.style.display = rule && rule.requires_extended_hitch_pin ? "" : "none";
  }
}

function runHFHardwareLogic() {
  renderHardwareBox();
  renderHardwareUpsells();
}

document.addEventListener("DOMContentLoaded", runHFHardwareLogic);
document.addEventListener("change", function () {
  setTimeout(runHFHardwareLogic, 200);
});